<div [ngClass]="isHidden ? 'pdfPageClass':'pdfPageClass'" id="pdfPage">
  <div class="top">
    <div class="buttonContainer">
      <div style="width: 595px; margin: 0 auto" class="mt-3">
        <div class="mt-1 sign-in-btn d-flex justify-content-between flex-wrap">
          <ng-container *ngIf="isVisibleButton">
            <button (click)="backClicked()">Back</button>
          </ng-container>
          <button (click)="print()">Print</button>
        </div>
      </div>
    </div>
  </div>
  <div class="pdf-component" #pdfContent *ngIf="pdfDetail">
    <div class="pdf-wrapper">
      <div class="pdf-inner">
        <div class="" id="capture">
          <div class="pdf-top">
            <div class="pdf-top-left">
              <ng-container *ngIf="isAgent">
                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 333 320">
                  <defs>
                    <style>
                      .cls-1 {
                        fill: #2c5c84;
                      }
                      .cls-2 {
                        fill: #f97923;
                      }
                      .cls-3 {
                        fill: #d0d0d0;
                      }
                      .cls-4 {
                        fill: #fff;
                      }
                    </style>
                  </defs>
                  <path
                    class="cls-1"
                    d="M58.78,300.55a5.63,5.63,0,0,1-1.59,1.93,7.1,7.1,0,0,1-2.35,1.17A10.22,10.22,0,0,1,52,304H47.42v6.64H45.3V291.87h7a9.32,9.32,0,0,1,2.88.42,6.58,6.58,0,0,1,2.23,1.18,5.09,5.09,0,0,1,1.43,1.88,6.11,6.11,0,0,1,.5,2.51A5.77,5.77,0,0,1,58.78,300.55Zm-2.91-5.68a6,6,0,0,0-3.68-1H47.42v8.28h4.66a7.1,7.1,0,0,0,2.12-.3,5,5,0,0,0,1.64-.84,3.7,3.7,0,0,0,1-1.32,4,4,0,0,0,.36-1.71A3.59,3.59,0,0,0,55.87,294.87Z"
                  />
                  <path
                    class="cls-1"
                    d="M81.92,310.68l-5.46-7.31H71.09v7.31H69V291.87h8.09a9.05,9.05,0,0,1,2.8.41A6,6,0,0,1,82,293.42a5,5,0,0,1,1.37,1.77,5.41,5.41,0,0,1,.48,2.3,5.59,5.59,0,0,1-.37,2.11,4.8,4.8,0,0,1-1.06,1.61,6.05,6.05,0,0,1-1.63,1.15,8,8,0,0,1-2,.64l5.77,7.68Zm-1.46-15.86a5.62,5.62,0,0,0-3.55-1H71.09v7.66h5.79a6.64,6.64,0,0,0,1.94-.27,4.84,4.84,0,0,0,1.54-.77,3.55,3.55,0,0,0,1-1.23,3.63,3.63,0,0,0,.36-1.64A3.27,3.27,0,0,0,80.46,294.82Z"
                  />
                  <path
                    class="cls-1"
                    d="M111.77,305a9.78,9.78,0,0,1-2,3.1,9.38,9.38,0,0,1-7,2.93,9.55,9.55,0,0,1-3.91-.78,9.28,9.28,0,0,1-5-5.2,10.3,10.3,0,0,1,0-7.44,9.78,9.78,0,0,1,2-3.1,9.88,9.88,0,0,1,10.87-2.15,9.28,9.28,0,0,1,3,2.11,9.17,9.17,0,0,1,2,3.09,10.3,10.3,0,0,1,0,7.44Zm-2.06-6.7a7.42,7.42,0,0,0-1.54-2.48,7.58,7.58,0,0,0-2.35-1.66,7.15,7.15,0,0,0-3-.62,7.08,7.08,0,0,0-3,.61,6.91,6.91,0,0,0-2.32,1.65A7.72,7.72,0,0,0,96,298.23a8.14,8.14,0,0,0-.55,3,8.27,8.27,0,0,0,.55,3,7.58,7.58,0,0,0,1.54,2.48,7.7,7.7,0,0,0,2.35,1.66,7.15,7.15,0,0,0,3,.62,7.23,7.23,0,0,0,3-.6,7,7,0,0,0,2.32-1.66,7.54,7.54,0,0,0,1.52-2.46,8.14,8.14,0,0,0,.55-3A8.27,8.27,0,0,0,109.71,298.27Z"
                  />
                  <path class="cls-1" d="M136.19,293.83H124.8v6.72H135v1.93H124.8v8.2h-2.12V291.87h13.51Z" />
                  <path class="cls-1" d="M148.34,291.87v18.81h-2.12V291.87Z" />
                  <path class="cls-1" d="M166.66,310.68h-2.12V293.83h-6.31v-2H173v2h-6.32Z" />
                  <path
                    class="cls-1"
                    d="M212.31,300.55a5.77,5.77,0,0,1-1.6,1.93,6.91,6.91,0,0,1-2.35,1.17,10.22,10.22,0,0,1-2.85.39h-4.57v6.64h-2.12V291.87h7a9.38,9.38,0,0,1,2.89.42,6.68,6.68,0,0,1,2.23,1.18,5.07,5.07,0,0,1,1.42,1.88,6.11,6.11,0,0,1,.5,2.51A5.89,5.89,0,0,1,212.31,300.55Zm-2.92-5.68a6,6,0,0,0-3.68-1h-4.77v8.28h4.67a7,7,0,0,0,2.11-.3,4.89,4.89,0,0,0,1.64-.84,3.7,3.7,0,0,0,1-1.32,3.83,3.83,0,0,0,.37-1.71A3.57,3.57,0,0,0,209.39,294.87Z"
                  />
                  <path class="cls-1" d="M222.49,291.87h2.13v16.85H235.2v2H222.49Z" />
                  <path class="cls-1" d="M262.36,310.68h-2.28l-2.2-5H247.64l-2.23,5h-2.17l8.57-18.94h2Zm-9.59-16.44-4.3,9.59H257Z" />
                  <path class="cls-1" d="M285.63,291.87h2.07v18.81H286l-12.14-15.42v15.42H271.8V291.87h2l11.85,15.07Z" />
                  <rect class="cls-2" x="133.19" y="64.97" width="33.31" height="133.26" />
                  <polyline class="cls-1" points="199.81 98.51 199.81 198.23 166.5 198.23 166.5 9 199.81 9 199.81 98.51" />
                  <path
                    class="cls-3"
                    d="M155.62,222.45c-.5,0-.85.05-1.2.05H134.71c-1.84,0-2.67-.85-2.67-2.7q0-21.23,0-42.44a1.78,1.78,0,0,1,.63-1q3.7-3.34,7.45-6.65c5.09-4.49,10.2-9,15.28-13.48,2.73-2.42,5.42-4.88,8.13-7.32.82-.74,1.63-1.49,2.5-2.16a.93.93,0,0,1,.9.05c2.4,2.08,4.77,4.21,7.16,6.32,2.68,2.36,5.38,4.7,8,7.07s5.4,4.88,8.13,7.3,5.21,4.57,7.81,6.86c.91.8,1.83,1.6,2.68,2.45.18.17.17.59.17.89q0,15.41,0,30.81c0,3.73,0,7.47,0,11.2,0,2-.81,2.82-2.79,2.82H178.24c-.25,0-.5,0-.91,0v-1.15c0-5.74,0-11.49,0-17.23a2.52,2.52,0,0,0-2.72-2.7c-5.49.14-11,.05-16.48.05-1.71,0-2.5.74-2.5,2.46,0,5.64,0,11.27,0,16.91Z"
                  />
                  <path
                    class="cls-3"
                    d="M215.54,179.62c-1.58,1.78-3.13,3.43-4.55,5.19-.53.65-.9.58-1.39.15-1.6-1.43-3.18-2.88-4.79-4.3-2.78-2.47-5.57-4.91-8.35-7.38-2.54-2.25-5.06-4.52-7.6-6.77-3.23-2.86-6.49-5.7-9.73-8.57-2.48-2.2-4.94-4.43-7.42-6.65-1.7-1.52-3.42-3-5.18-4.58L122.7,185.54l-5.24-5.93,9.41-8.27c2.14-1.89,4.26-3.81,6.39-5.7,3.18-2.82,6.38-5.62,9.56-8.44,2.16-1.92,4.29-3.89,6.45-5.81,2.53-2.26,5.09-4.49,7.64-6.74,2.76-2.43,5.52-4.86,8.26-7.32,1.14-1,1.36-1.12,2.51-.13,2.57,2.22,5.09,4.5,7.64,6.75,3.72,3.29,7.45,6.56,11.18,9.85l7.44,6.62q4.91,4.34,9.8,8.67c2.59,2.31,5.16,4.63,7.74,6.94C212.81,177.22,214.14,178.39,215.54,179.62Z"
                  />
                  <path class="cls-4" d="M155.39,179.93h9.66v9.7h-9.66Z" />
                  <path
                    class="cls-4"
                    d="M167.92,179.93h9.63a2.73,2.73,0,0,1,.1.53c0,2.82,0,5.63,0,8.45,0,.26-.3.75-.47.75-3,.05-6.11,0-9.24,0Z"
                  />
                  <path
                    class="cls-4"
                    d="M165.11,177.2h-9.7a53.66,53.66,0,0,1,0-5.82,4.75,4.75,0,0,1,5-3.92,4.85,4.85,0,0,1,4.61,4.53C165.17,173.69,165.11,175.41,165.11,177.2Z"
                  />
                  <path
                    class="cls-4"
                    d="M177.61,177.22h-9.84a48.7,48.7,0,0,1,.33-6.21,4.68,4.68,0,0,1,5-3.55,4.78,4.78,0,0,1,4.46,4.36C177.69,173.58,177.61,175.35,177.61,177.22Z"
                  />
                  <path class="cls-2" d="M60.09,241.16h10l16,37.88H75l-2.74-6.72H57.72L55,279h-11Zm9.13,23L65,253.52l-4.25,10.69Z" />
                  <path
                    class="cls-2"
                    d="M98.92,260.34v-.11c0-11,8.6-19.55,20.26-19.55a21.94,21.94,0,0,1,15.26,5.48l-6.13,7.36a13.26,13.26,0,0,0-9.08-3.55c-5.43,0-9.62,4.57-9.62,10.32v.11c0,6.07,4.25,10.42,10.21,10.42a10.64,10.64,0,0,0,6-1.56v-4.57h-7.42v-7.62h17.3V274a25.38,25.38,0,0,1-16.33,5.8C107.68,279.79,98.92,271.73,98.92,260.34Z"
                  />
                  <path class="cls-2" d="M154.36,241.43h30.25v8.87H164.67V256h18.06v8.22H164.67v6h20.21V279H154.36Z" />
                  <path class="cls-2" d="M203,241.43h9.72l15.47,19.88V241.43h10.32V279h-9.13l-16.07-20.63V279H203Z" />
                  <path class="cls-2" d="M267.22,250.56H255.94v-9.13h33v9.13H277.64V279H267.22Z" />
                </svg>
              </ng-container>
              <ng-container *ngIf="!isAgent">
                <svg width="134" height="130" viewBox="0 0 134 130" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0 99.6875H4.63432L8.43052 105.85L12.2267 99.6875H16.861V115.563H12.4732V106.442L8.43052 112.654H8.33191L4.28921 106.491V115.563H0V99.6875Z"
                    fill="#F97923"
                  />
                  <path
                    d="M19.1777 107.674C19.1777 103.089 22.8753 99.3423 27.7562 99.3423C32.637 99.3423 36.2853 102.991 36.2853 107.576V107.625C36.2853 112.21 32.5877 115.908 27.7069 115.908C22.826 115.908 19.1777 112.21 19.1777 107.674ZM31.7989 107.674C31.7989 105.357 30.1226 103.336 27.7069 103.336C25.2911 103.336 23.7135 105.308 23.7135 107.576V107.625C23.7135 109.942 25.3897 111.914 27.7562 111.914C30.1719 111.914 31.7989 109.942 31.7989 107.674Z"
                    fill="#F97923"
                  />
                  <path
                    d="M38.5547 99.6875H46.0485C48.4642 99.6875 50.1405 100.328 51.2251 101.413C52.1618 102.3 52.6548 103.533 52.6548 105.111V105.16C52.6548 107.576 51.373 109.203 49.401 110.041L53.1972 115.563H48.1191L44.9146 110.731H44.8653H42.9918V115.563H38.5547V99.6875ZM45.8513 107.28C47.3303 107.28 48.2177 106.54 48.2177 105.406V105.357C48.2177 104.125 47.3303 103.484 45.8513 103.484H42.9918V107.28H45.8513Z"
                    fill="#F97923"
                  />
                  <path d="M58.7666 103.533H53.9844V99.6875H67.9366V103.533H63.1544V115.563H58.7666V103.533Z" fill="#F97923" />
                  <path
                    d="M68.627 107.674C68.627 102.991 72.2752 99.3423 77.2054 99.3423C80.0155 99.3423 81.9876 100.18 83.6638 101.659L81.1002 104.765C79.9662 103.829 78.8323 103.286 77.2547 103.286C74.9868 103.286 73.212 105.209 73.212 107.625V107.674C73.212 110.238 74.9868 112.062 77.5012 112.062C78.5858 112.062 79.3746 111.816 80.0648 111.421V109.498H76.9096V106.294H84.2062V113.442C82.5299 114.823 80.2128 115.908 77.304 115.908C72.3246 115.908 68.627 112.456 68.627 107.674Z"
                    fill="#F97923"
                  />
                  <path
                    d="M92.1439 99.5388H96.3838L103.138 115.562H98.4052L97.2713 112.702H91.1579L90.024 115.562H85.3896L92.1439 99.5388ZM95.9894 109.3L94.2146 104.765L92.4397 109.3H95.9894Z"
                    fill="#F97923"
                  />
                  <path
                    d="M103.139 107.674C103.139 102.991 106.787 99.3423 111.717 99.3423C114.527 99.3423 116.499 100.18 118.176 101.659L115.612 104.765C114.478 103.829 113.344 103.286 111.766 103.286C109.449 103.286 107.724 105.209 107.724 107.625V107.674C107.724 110.238 109.499 112.062 112.013 112.062C113.098 112.062 113.886 111.816 114.577 111.421V109.498H111.421V106.294H118.718V113.442C117.042 114.823 114.724 115.908 111.816 115.908C106.836 115.908 103.139 112.456 103.139 107.674Z"
                    fill="#F97923"
                  />
                  <path
                    d="M121.132 99.6875H133.901V103.434H125.471V105.85H133.113V109.301H125.471V111.816H134V115.563H121.083V99.6875H121.132Z"
                    fill="#F97923"
                  />
                  <path
                    d="M5.96699 124.635C5.81909 124.98 5.57258 125.226 5.27678 125.473C4.98097 125.67 4.68516 125.867 4.29075 125.966C3.89634 126.064 3.50193 126.114 3.10752 126.114H1.18477V128.924H0.248047V120.986H3.20612C3.64983 120.986 4.04424 121.036 4.43865 121.184C4.78376 121.282 5.12887 121.479 5.37538 121.677C5.62189 121.874 5.81909 122.17 5.96699 122.465C6.1149 122.761 6.1642 123.156 6.1642 123.55C6.2135 123.944 6.1149 124.339 5.96699 124.635ZM4.73446 122.268C4.34005 121.972 3.84704 121.824 3.15682 121.824H1.13547V125.325H3.10752C3.45263 125.325 3.74844 125.276 3.99494 125.177C4.24145 125.078 4.48796 124.98 4.68516 124.832C4.88237 124.684 5.03027 124.487 5.12887 124.29C5.22748 124.092 5.27678 123.846 5.27678 123.55C5.32608 122.958 5.12887 122.564 4.73446 122.268Z"
                    fill="#2C5C84"
                  />
                  <path
                    d="M19.1795 128.924L16.8623 125.818H14.5945V128.924H13.707V120.986H17.1088C17.5525 120.986 17.9469 121.036 18.2921 121.134C18.6372 121.233 18.933 121.43 19.1795 121.627C19.426 121.824 19.6232 122.071 19.7711 122.367C19.919 122.663 19.9683 122.958 19.9683 123.353C19.9683 123.698 19.919 123.994 19.8204 124.24C19.7218 124.487 19.5739 124.733 19.3767 124.93C19.1795 125.128 18.933 125.276 18.6865 125.423C18.44 125.571 18.1441 125.621 17.8483 125.719L20.2641 128.973H19.1795V128.924ZM18.5879 122.219C18.2427 121.923 17.7497 121.824 17.1088 121.824H14.6438V125.078H17.1088C17.4046 125.078 17.7004 125.029 17.9469 124.98C18.1934 124.881 18.3907 124.783 18.5879 124.635C18.7851 124.487 18.933 124.339 19.0316 124.092C19.1302 123.895 19.1795 123.649 19.1795 123.402C19.1302 122.909 18.933 122.515 18.5879 122.219Z"
                    fill="#2C5C84"
                  />
                  <path
                    d="M35.252 126.508C35.0548 127.001 34.759 127.444 34.4139 127.839C34.0688 128.233 33.625 128.529 33.132 128.726C32.639 128.973 32.0967 129.071 31.4558 129.071C30.8642 129.071 30.3219 128.973 29.8288 128.726C29.3358 128.529 28.8921 128.233 28.547 127.839C28.2019 127.444 27.9061 127.05 27.7089 126.557C27.5117 126.064 27.4131 125.522 27.4131 124.979C27.4131 124.437 27.5117 123.895 27.7089 123.402C27.9061 122.909 28.2019 122.465 28.547 122.071C28.8921 121.676 29.3358 121.38 29.8288 121.183C30.3219 120.937 30.8642 120.838 31.5051 120.838C32.0967 120.838 32.639 120.937 33.132 121.183C33.625 121.38 34.0688 121.676 34.4139 122.071C34.759 122.465 35.0548 122.859 35.252 123.352C35.4492 123.846 35.5478 124.388 35.5478 124.93C35.5478 125.472 35.4492 126.015 35.252 126.508ZM34.3646 123.698C34.2167 123.303 33.9702 122.958 33.7236 122.662C33.4278 122.366 33.132 122.12 32.7376 121.972C32.3432 121.775 31.9488 121.726 31.5051 121.726C31.0614 121.726 30.6177 121.824 30.2726 121.972C29.8781 122.12 29.5823 122.366 29.2865 122.662C28.9907 122.958 28.7935 123.303 28.6456 123.698C28.4977 124.092 28.3991 124.536 28.3991 124.979C28.3991 125.423 28.4977 125.867 28.6456 126.261C28.7935 126.656 29.04 127.001 29.2865 127.297C29.5823 127.592 29.8781 127.839 30.2726 127.987C30.667 128.184 31.0614 128.233 31.5051 128.233C31.9488 128.233 32.3925 128.135 32.7376 127.987C33.132 127.839 33.4278 127.592 33.7236 127.297C34.0195 127.001 34.2167 126.656 34.3646 126.261C34.5125 125.867 34.6111 125.423 34.6111 124.979C34.6111 124.536 34.5618 124.092 34.3646 123.698Z"
                    fill="#2C5C84"
                  />
                  <path
                    d="M49.008 121.824H44.1765V124.684H48.4657V125.522H44.1765V128.973H43.2891V121.035H49.008V121.824Z"
                    fill="#2C5C84"
                  />
                  <path d="M57.5857 120.986V128.924H56.6982V120.986H57.5857Z" fill="#2C5C84" />
                  <path d="M68.827 128.924H67.9396V121.824H65.2773V120.986H71.4893V121.824H68.827V128.924Z" fill="#2C5C84" />
                  <path
                    d="M91.5534 124.635C91.4055 124.98 91.159 125.226 90.8632 125.473C90.5674 125.67 90.2716 125.867 89.8772 125.966C89.4828 126.064 89.0884 126.114 88.694 126.114H86.7712V128.924H85.8838V120.986H88.8419C89.2856 120.986 89.68 121.036 90.0744 121.184C90.4195 121.282 90.7646 121.479 91.0111 121.677C91.2576 121.874 91.4548 122.17 91.6027 122.465C91.7506 122.761 91.7999 123.156 91.7999 123.55C91.7999 123.944 91.7013 124.339 91.5534 124.635ZM90.3209 122.268C89.9265 121.972 89.4335 121.824 88.7433 121.824H86.7219V125.325H88.694C89.0391 125.325 89.3349 125.276 89.5814 125.177C89.8279 125.078 90.0744 124.98 90.2716 124.832C90.4688 124.684 90.6167 124.487 90.7153 124.29C90.8139 124.092 90.8632 123.846 90.8632 123.55C90.9125 122.958 90.7153 122.564 90.3209 122.268Z"
                    fill="#2C5C84"
                  />
                  <path d="M99.2949 120.986H100.182V128.086H104.669V128.924H99.2949V120.986Z" fill="#2C5C84" />
                  <path
                    d="M119.606 128.924H118.62L117.683 126.804H113.345L112.408 128.924H111.521L115.12 120.937H115.958L119.606 128.924ZM115.514 121.972L113.69 126.015H117.289L115.514 121.972Z"
                    fill="#2C5C84"
                  />
                  <path
                    d="M132.869 120.986H133.756V128.924H133.017L127.889 122.416V128.924H127.002V120.986H127.84L132.869 127.346V120.986Z"
                    fill="#2C5C84"
                  />
                  <path
                    d="M79.5227 83.1712C79.8678 84.5023 80.1636 85.587 80.4594 86.6716C80.8538 87.9041 80.4101 88.7422 79.2269 89.2353C78.9804 89.3339 78.7339 89.4325 78.5367 89.4818C73.8038 91.4045 73.8531 91.4045 71.0429 87.2632C70.5499 86.5237 69.5145 86.08 68.6271 85.7842C67.8383 85.5377 66.8523 85.7349 66.0142 85.6856C64.3379 85.5377 63.3026 86.2772 62.5138 87.7069C60.2952 91.7496 60.591 91.5524 56.3018 89.679C52.9493 88.2492 52.8014 88.1999 54.034 84.6502C54.7735 82.4317 54.0833 81.0019 52.5056 79.4736C51.0266 77.9946 49.5968 76.8606 47.3783 77.896C46.7374 78.1918 45.9978 78.4876 45.4062 78.389C44.6174 78.2411 43.5821 77.8467 43.1877 77.2551C42.3989 75.9732 42.0044 74.4942 41.4128 73.1138C40.9198 71.9798 41.2649 71.1417 42.3003 70.5994C42.4975 70.4515 42.744 70.3036 42.9412 70.2543C46.6388 69.1696 46.836 66.2609 46.5402 63.1549C46.4416 62.3661 45.8499 61.5773 45.3076 60.9856C44.8639 60.4926 44.1737 60.2461 43.5328 59.901C40.9198 58.3727 40.8212 58.2741 42.103 55.4639C44.0751 51.0761 43.1877 50.5831 48.6108 52.1607C49.4982 52.4072 50.7308 51.8649 51.6675 51.4212C52.3577 51.0761 52.8507 50.2873 53.4423 49.745C54.6749 48.6603 54.9707 47.4771 54.527 45.8502C53.3437 41.7088 53.393 41.6595 57.485 40.0326C58.0767 39.7861 58.6683 39.5889 59.2599 39.3424C60.3938 38.8494 61.1826 39.2438 61.7743 40.2791C61.9222 40.5749 62.0701 40.8214 62.218 41.1172C64.0914 44.519 65.817 45.3078 69.5638 44.4697C70.2048 44.3218 70.895 43.7795 71.3387 43.2372C71.9303 42.4977 72.374 41.6595 72.7684 40.8214C73.5079 39.3424 74.5433 38.948 76.0223 39.7368C76.1702 39.8354 76.3674 39.8847 76.5646 39.9833C81.1003 41.9554 81.051 41.906 80.065 46.8362C79.9171 47.6743 80.3115 48.7589 80.7552 49.597C81.1003 50.2873 81.8892 50.731 82.4315 51.3719C83.5654 52.7523 84.9458 53.1467 86.6221 52.4565C87.3123 52.21 88.0518 52.0621 88.7913 51.8649C89.9746 51.5691 90.7634 51.9635 91.2071 53.0974C91.7494 54.4779 92.341 55.9076 92.8833 57.288C93.3271 58.422 92.9819 59.2601 91.8973 59.8024C91.6508 59.901 91.4536 60.0489 91.2564 60.1475C87.6081 62.1689 87.0658 63.2535 87.8053 67.4441C87.9532 68.1836 88.5941 68.9724 89.2351 69.5148C89.9253 70.1064 90.8127 70.5008 91.6508 70.9445C92.9819 71.6347 93.2285 72.6207 92.5875 73.9519C92.0452 75.1351 91.5029 76.3676 91.0099 77.6002C90.5169 78.882 89.6295 79.3257 88.2983 78.882C88.0518 78.7834 87.8053 78.7341 87.5588 78.6848C83.9105 77.6495 81.7906 78.4383 79.8678 81.6429C79.6706 82.0866 79.6213 82.7768 79.5227 83.1712ZM66.31 50.731C58.3232 51.224 52.3084 57.9783 52.7521 65.9651C53.1958 73.9519 59.9994 79.9666 67.9862 79.5229C75.973 79.0792 82.0371 72.2263 81.5441 64.2888C81.1003 56.3513 74.2475 50.238 66.31 50.731Z"
                    fill="#D0D0D0"
                  />
                  <path d="M67.0977 23.6643H53.0469V79.9664H67.0977V23.6643Z" fill="#F97923" />
                  <path d="M81.1973 0H67.1465V79.9666H81.1973V0Z" fill="#2C5C84" />
                  <path
                    d="M91.6508 70.895C90.8127 70.4513 89.9253 70.0569 89.2351 69.4653C88.5941 68.9229 87.9532 68.1834 87.8053 67.3946C87.0658 63.204 87.6081 62.1194 91.2564 60.098C91.4536 59.9994 91.7001 59.8515 91.8973 59.7529C92.9819 59.2106 93.3271 58.3725 92.8833 57.2385C92.341 55.8088 91.7494 54.4284 91.2071 53.0479C90.7634 51.914 89.9746 51.5196 88.7913 51.8154C88.0518 52.0126 87.3123 52.1605 86.6221 52.407C84.9458 53.0479 83.5654 52.7028 82.4315 51.3224C82.0864 50.928 81.6427 50.5829 81.2483 50.1885V61.8729C81.4455 62.6617 81.5441 63.4998 81.5934 64.3379C82.0371 72.3247 75.973 79.1283 68.0355 79.572C60.0487 80.0157 53.2451 74.001 52.8014 66.0142C52.7028 64.6337 52.8507 63.3519 53.0972 62.0701V50.1392C52.6535 50.6322 52.2098 51.1745 51.6675 51.421C50.7308 51.8647 49.4982 52.407 48.6108 52.1605C43.237 50.5829 44.0751 51.0266 42.103 55.4637C40.8705 58.2739 40.9198 58.3725 43.5328 59.9008C44.1244 60.2459 44.8639 60.4924 45.3076 60.9854C45.8499 61.6264 46.4909 62.4152 46.5402 63.1547C46.8853 66.2114 46.6388 69.1694 42.9412 70.2541C42.6947 70.3034 42.4975 70.5006 42.3003 70.5992C41.2649 71.1908 40.9198 71.9796 41.4128 73.1136C42.0044 74.494 42.3989 76.0223 43.1877 77.2549C43.5821 77.8958 44.6174 78.2409 45.4062 78.3888C45.9978 78.4874 46.7867 78.1916 47.3783 77.8958C49.5968 76.9097 50.9773 77.9944 52.5056 79.4734C54.034 81.0018 54.7735 82.3822 54.034 84.65C52.8014 88.1997 52.9493 88.1997 56.3018 89.6788C60.591 91.5029 60.2952 91.7001 62.5138 87.7067C63.3026 86.277 64.3379 85.5375 66.0142 85.6854C66.9016 85.7347 67.8383 85.5375 68.6271 85.784C69.5145 86.0798 70.5499 86.5235 71.0429 87.263C73.8531 91.4043 73.8038 91.4536 78.5367 89.4816C78.7832 89.383 79.0297 89.2844 79.2269 89.2351C80.4101 88.7421 80.8045 87.9039 80.4594 86.6714C80.1143 85.5868 79.8678 84.5021 79.5227 83.171C79.6213 82.7273 79.6706 82.0864 79.9664 81.5934C81.8399 78.3395 83.9598 77.5507 87.6574 78.6353C87.9039 78.6846 88.1504 78.7832 88.3969 78.8325C89.6788 79.2762 90.5662 78.8325 91.1085 77.5507C91.6015 76.3181 92.0945 75.0856 92.6861 73.9024C93.2285 72.5712 92.9819 71.5852 91.6508 70.895Z"
                    fill="#D0D0D0"
                  />
                </svg>
              </ng-container>
            </div>
            <div class="pdf-top-right">
              <div class="pdf-date">
                <p>
                  <span>Date:</span><label>{{ currentDate | date : 'dd-MM-yyyy' }}</label>
                </p>
              </div>
              <div class="report-heading">
                <svg width="344" height="54" viewBox="0 0 344 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M344 0V54H0L47 0H344Z" fill="#231F20" />
                </svg>

                <h3>Assessment Report</h3>
              </div>
              <div class="user-detail">
                <div class="user-detail-left">
                  <p class="word-break">{{ pdfDetail.user.name }}</p>
                </div>
                <div class="user-detail-right mt-0">
                  <a href="tel:{{ pdfDetail.user.mobileNo }}">
                    <span
                      ><svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.5 7.21V8.978C9.50006 9.10459 9.4521 9.22649 9.3658 9.3191C9.2795 9.41171 9.16128 9.46814 9.035 9.477C8.8165 9.492 8.638 9.5 8.5 9.5C4.0815 9.5 0.5 5.9185 0.5 1.5C0.5 1.362 0.5075 1.1835 0.523 0.965C0.531861 0.838722 0.588291 0.720505 0.680902 0.634204C0.773513 0.547903 0.895411 0.499943 1.022 0.5H2.79C2.85202 0.499937 2.91185 0.52293 2.95786 0.56451C3.00388 0.606091 3.0328 0.663291 3.039 0.725C3.0505 0.84 3.061 0.9315 3.071 1.001C3.17037 1.69446 3.374 2.36892 3.675 3.0015C3.7225 3.1015 3.6915 3.221 3.6015 3.285L2.5225 4.056C3.18223 5.59323 4.40727 6.81827 5.9445 7.478L6.7145 6.401C6.74597 6.357 6.79189 6.32544 6.84425 6.31183C6.8966 6.29821 6.95208 6.3034 7.001 6.3265C7.63351 6.62693 8.30779 6.83006 9.001 6.929C9.0705 6.939 9.162 6.95 9.276 6.961C9.33762 6.96732 9.3947 6.99629 9.43618 7.04229C9.47765 7.08829 9.50058 7.14806 9.5005 7.21H9.5Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                    <label>
                      {{ pdfDetail.user.mobileNo }}
                    </label>
                  </a>
                  <a href="mailto:{{pdfDetail?.user?.email}}">
                    <!-- <a href="mailto:johndoe123@gmail.com"> -->
                    <span>
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M0.5 0.5H9.5C9.63261 0.5 9.75979 0.552678 9.85355 0.646447C9.94732 0.740215 10 0.867392 10 1V9C10 9.13261 9.94732 9.25979 9.85355 9.35355C9.75979 9.44732 9.63261 9.5 9.5 9.5H0.5C0.367392 9.5 0.240215 9.44732 0.146447 9.35355C0.0526784 9.25979 0 9.13261 0 9V1C0 0.867392 0.0526784 0.740215 0.146447 0.646447C0.240215 0.552678 0.367392 0.5 0.5 0.5ZM5.03 4.8415L1.824 2.119L1.1765 2.881L5.0365 6.1585L8.827 2.8785L8.173 2.122L5.0305 4.8415H5.03Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                    <label>
                      {{ pdfDetail.user.email }}
                    </label>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="pdf-user-detial-wrapper">
            <div class="pdf-user-detial-inner">
              <h2>Revenue</h2>
              <div class="pdf-user-detial-main">
                <div class="pdf-user-detial-left">
                  <ul>
                    <li>
                      <span>Previous Year Volume:</span><label>$ {{ pdfDetail.currentVolume | number : '1.0-0' }}</label>
                    </li>
                    <li>
                      <span> Previous Year Income:</span
                      ><label
                        >$
                        {{ pdfDetail.currentIncome | number : '1.0-0' }}
                      </label>
                    </li>
                    <div *ngIf="!isAgentOrProfit">
                      <li>
                        <span>Number of Loans:</span><label> {{ pdfDetail.noOfLoans | number : '1.0-0' }}</label>
                      </li>
                      <li>
                        <span>Avg Loan size:</span><label>$ {{ pdfDetail.avgLoanSize | number : '1.0-0' }}</label>
                      </li>
                    </div>
                    <div *ngIf="isAgentOrProfit">
                      <li>
                        <span>Average (GCI) Commission:</span><label>{{ pdfDetail.averageCommission | number : '1.0-2' }} %</label>
                      </li>
                      <!-- <li>
                        <span>Number of Client :</span><label> {{ pdfDetail.numberOfClient | number : '1.0-0' }}</label>
                      </li> -->
                      <li>
                        <span>Hours Worked:</span><label> {{ pdfDetail.workingHours | number : '1.0-0' }}</label>
                      </li>
                      <li>
                        <span>Number of Listing Previous Year:</span><label> {{ pdfDetail.numberOfListings | number : '1.0-0' }}</label>
                      </li>
                      <li>
                        <span>Number of buyer Previous Year:</span><label> {{ pdfDetail.numberOfBuyers | number : '1.0-0' }}</label>
                      </li>
                      <li>
                        <span>Average Sales Price:</span><label>$ {{ pdfDetail.averageSalesPrice | number : '1.0-0' }}</label>
                      </li>
                      <li>
                        <span>Total Home Sold Previous Year:</span><label> {{ pdfDetail.homeSold | number : '1.0-0' }}</label>
                      </li>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
            <div class="pdf-user-detial-inner1">
              <div class="pdf-profit-advisor" *ngIf="isAgentOrProfit && profitAdvisor">
                <h2>Profit Advisor</h2>
                <div class="pdf-profit-advisor-left d-flex flex-wrap align-items-center">
                  <div class="pdf-profit-advisor-left-img">
                    <img [src]="profitAdvisor.userImage" onerror="this.onerror=null;this.src='/assets/images/default.jpg';" />
                  </div>
                  <div class="pdf-profit-advisor-left-content">
                    <p>{{ profitAdvisor.name | titlecase }}</p>
                    <div class="user-detail-right mt-0">
                      <a href="tel:{{ pdfDetail.user.mobileNo }}"> 
                        <!-- +1 201-654-9873 -->
                        <span>
                          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              _ngcontent-ng-cli-universal-c113=""
                              d="M9.5 7.21V8.978C9.50006 9.10459 9.4521 9.22649 9.3658 9.3191C9.2795 9.41171 9.16128 9.46814 9.035 9.477C8.8165 9.492 8.638 9.5 8.5 9.5C4.0815 9.5 0.5 5.9185 0.5 1.5C0.5 1.362 0.5075 1.1835 0.523 0.965C0.531861 0.838722 0.588291 0.720505 0.680902 0.634204C0.773513 0.547903 0.895411 0.499943 1.022 0.5H2.79C2.85202 0.499937 2.91185 0.52293 2.95786 0.56451C3.00388 0.606091 3.0328 0.663291 3.039 0.725C3.0505 0.84 3.061 0.9315 3.071 1.001C3.17037 1.69446 3.374 2.36892 3.675 3.0015C3.7225 3.1015 3.6915 3.221 3.6015 3.285L2.5225 4.056C3.18223 5.59323 4.40727 6.81827 5.9445 7.478L6.7145 6.401C6.74597 6.357 6.79189 6.32544 6.84425 6.31183C6.8966 6.29821 6.95208 6.3034 7.001 6.3265C7.63351 6.62693 8.30779 6.83006 9.001 6.929C9.0705 6.939 9.162 6.95 9.276 6.961C9.33762 6.96732 9.3947 6.99629 9.43618 7.04229C9.47765 7.08829 9.50058 7.14806 9.5005 7.21H9.5Z"
                              fill="black"
                            ></path>
                          </svg>
                        </span>
                        <label> {{ profitAdvisor.mobileNo }} </label>
                      </a>
                      <a href="mailto:{{pdfDetail?.user?.email}}">
                    <!-- <a href="mailto:johndoe123@gmail.com"> -->
                        <span>
                          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              _ngcontent-ng-cli-universal-c113=""
                              d="M0.5 0.5H9.5C9.63261 0.5 9.75979 0.552678 9.85355 0.646447C9.94732 0.740215 10 0.867392 10 1V9C10 9.13261 9.94732 9.25979 9.85355 9.35355C9.75979 9.44732 9.63261 9.5 9.5 9.5H0.5C0.367392 9.5 0.240215 9.44732 0.146447 9.35355C0.0526784 9.25979 0 9.13261 0 9V1C0 0.867392 0.0526784 0.740215 0.146447 0.646447C0.240215 0.552678 0.367392 0.5 0.5 0.5ZM5.03 4.8415L1.824 2.119L1.1765 2.881L5.0365 6.1585L8.827 2.8785L8.173 2.122L5.0305 4.8415H5.03Z"
                              fill="black"
                            ></path>
                          </svg>
                        </span>
                        <label> {{ profitAdvisor.email }} </label>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="chart">
                <div>
                  <h2>Assessment Completion Success</h2>
                  <div #doughnutChartCanvas class="doughnut-canvas">
                    <doughnut-chart [OnPerChange]="answeredQuestionPer"> </doughnut-chart>
                  </div>
                </div>
                <div class="chart-specs">
                  <div class="color-wrapper">
                    <div *ngFor="let item of doughnutCharts.colors">
                      <div class="color-ref" [ngStyle]="{background: item}"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pdf-graph-wrapper d-flex">
            <div class="halfGaugeWidth">
              <div class="pdf-graph-box">
                <div class="chart">
                  <h3 class="text-center p-3">Income Gauge</h3>
                  <div class="gauge-chartContainer">
                    <div>
                      <div class="bar-chart-wrapper Income1" #Income1>
                        <div *ngIf="isAgentOrProfit">
                          <app-gauge-chart [chartType]="'Income1'" [setRevenueDetail]="chartConfig"> </app-gauge-chart>
                        </div>
                        <div *ngIf="!isAgentOrProfit">
                          <app-bar-chart
                            [chartType]="'Income1'"
                            [setTotalPerAndUnit]="totalPerAndUnit"
                            [setCurrentIncome]="pdfDetail?.currentIncome ?? 0"
                            [setBasicPoints]="pdfDetail?.basePoints ?? 0"
                            [setAvgLoanSize]="pdfDetail?.avgLoanSize ?? 0"
                          ></app-bar-chart>
                        </div>
                      </div>
                      <p class="text-center textCenter p-3">Previous Year Income</p>
                    </div>
                    <div>
                      <div class="bar-chart-wrapper Income2" #Income2>
                        <div *ngIf="isAgentOrProfit">
                          <app-gauge-chart [chartType]="'Income2'" [setRevenueDetail]="chartConfig"> </app-gauge-chart>
                        </div>
                        <div *ngIf="!isAgentOrProfit">
                          <app-bar-chart
                            [chartType]="'Income2'"
                            [setTotalPerAndUnit]="totalPerAndUnit"
                            [setCurrentIncome]="pdfDetail?.currentIncome ?? 0"
                            [setBasicPoints]="pdfDetail?.basePoints ?? 0"
                            [setAvgLoanSize]="pdfDetail?.avgLoanSize ?? 0"
                          ></app-bar-chart>
                        </div>
                      </div>
                      <p class="text-center textCenter p-3">Growth Plan Income</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="halfGaugeWidth">
              <div class="pdf-graph-box">
                <div class="chart">
                  <h3 class="text-center p-3">Units Gauge</h3>
                  <div class="gauge-chartContainer">
                    <div>
                      <div class="bar-chart-wrapper Unit1" #Unit1>
                        <div *ngIf="isAgentOrProfit">
                          <app-gauge-chart [chartType]="'Unit1'" [setRevenueDetail]="chartConfig"> </app-gauge-chart>
                        </div>
                        <div *ngIf="!isAgentOrProfit">
                          <app-bar-chart
                            [chartType]="'Unit1'"
                            [setNoOfLoan]="pdfDetail?.noOfLoans ?? 0"
                            [setTotalPerAndUnit]="totalPerAndUnit"
                          >
                          </app-bar-chart>
                        </div>
                      </div>
                      <p class="text-center textCenter p-3">Current Units</p>
                    </div>
                    <div>
                      <div class="bar-chart-wrapper Unit2" #Unit2>
                        <div *ngIf="isAgentOrProfit">
                          <app-gauge-chart [chartType]="'Unit2'" [setRevenueDetail]="chartConfig"> </app-gauge-chart>
                        </div>
                        <div *ngIf="!isAgentOrProfit">
                          <app-bar-chart
                            [chartType]="'Unit2'"
                            [setNoOfLoan]="pdfDetail?.noOfLoans ?? 0"
                            [setTotalPerAndUnit]="totalPerAndUnit"
                          ></app-bar-chart>
                        </div>
                      </div>
                      <p class="text-center p-3 textCenter">Growth Plan Units</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="halfGaugeWidth">
              <div class="pdf-graph-box">
                <div class="chart">
                  <h3 class="text-center p-3">Volume Gauge</h3>
                  <div class="gauge-chartContainer">
                    <div>
                      <div class="bar-chart-wrapper Volume1" #Volume1>
                        <div *ngIf="isAgentOrProfit">
                          <app-gauge-chart [chartType]="'Volume1'" [setRevenueDetail]="chartConfig"> </app-gauge-chart>
                        </div>
                        <div *ngIf="!isAgentOrProfit">
                          <app-bar-chart
                            [chartType]="'Volume1'"
                            [setCurrentVolume]="pdfDetail?.currentVolume ?? 0"
                            [setTotalPerAndUnit]="totalPerAndUnit"
                            [setAvgLoanSize]="pdfDetail?.avgLoanSize ?? 0"
                          >
                          </app-bar-chart>
                        </div>
                      </div>
                      <p class="text-center p-3 textCenter">Previous Year Volume</p>
                    </div>
                    <div>
                      <div class="bar-chart-wrapper Volume2" #Volume2>
                        <div *ngIf="isAgentOrProfit">
                          <app-gauge-chart [chartType]="'Volume2'" [setRevenueDetail]="chartConfig"> </app-gauge-chart>
                        </div>
                        <div *ngIf="!isAgentOrProfit">
                          <app-bar-chart
                            [chartType]="'Volume2'"
                            [setCurrentVolume]="pdfDetail?.currentVolume ?? 0"
                            [setTotalPerAndUnit]="totalPerAndUnit"
                            [setAvgLoanSize]="pdfDetail?.avgLoanSize ?? 0"
                          ></app-bar-chart>
                        </div>
                      </div>
                      <p class="text-center p-3 textCenter">Growth Plan Volume</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="halfGaugeWidth">
              <div class="pdf-graph-box">
                <div class="chart">
                  <h3 class="text-center p-3">Hourly Rate of Pay Gauge</h3>
                  <div class="gauge-chartContainer">
                    <div>
                      <div class="bar-chart-wrapper hours1" #hours1>
                        <div *ngIf="isAgentOrProfit">
                          <app-gauge-chart [chartType]="'hours1'" [setRevenueDetail]="chartConfig"> </app-gauge-chart>
                        </div>
                        <div *ngIf="!isAgentOrProfit">
                          <app-bar-chart
                            [setCurrentHoursIncome]="pdfDetail?.currentIncome ?? 0"
                            [chartType]="'hours1'"
                            [setTotalPerAndUnit]="totalPerAndUnit"
                            [setBasicPoints]="pdfDetail?.basePoints ?? 0"
                            [setAvgLoanSize]="pdfDetail?.avgLoanSize ?? 0"
                            [setCurrentHours]="pdfDetail?.workingHours ?? 2000"
                          ></app-bar-chart>
                        </div>
                      </div>
                      <p class="text-center textCenter p-3">Current Rate</p>
                    </div>
                    <div>
                      <div class="bar-chart-wrapper hours2" #hours2>
                        <div *ngIf="isAgentOrProfit">
                          <app-gauge-chart [chartType]="'hours2'" [setRevenueDetail]="chartConfig"> </app-gauge-chart>
                        </div>
                        <div *ngIf="!isAgentOrProfit">
                          <app-bar-chart
                            [setCurrentHoursIncome]="pdfDetail?.currentIncome ?? 0"
                            [chartType]="'hours2'"
                            [setTotalPerAndUnit]="totalPerAndUnit"
                            [setBasicPoints]="pdfDetail?.basePoints ?? 0"
                            [setAvgLoanSize]="pdfDetail?.avgLoanSize ?? 0"
                            [setCurrentHours]="pdfDetail?.workingHours ?? 2000"
                          ></app-bar-chart>
                        </div>
                      </div>
                      <p class="text-center textCenter p-3">Growth Plan Rate</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pdf-question-wrapper">
          <div class="pdf-question-inner">
            <div class="">
              <ul>
                <li class="questions">
                  <h3>Questions</h3>
                </li>
                <li class="answers">
                  <h3>Answers</h3>
                </li>
                <li class="percentage">
                  <h3>Unit</h3>
                </li>
              </ul>
            </div>
            <div class="pdf-question-content">
              <ng-container *ngFor="let category of assessmentQuestionList; index as i">
                <div class="new-ass-que-left-content">
                  <div class="new-ass-que-left-content-head pdf-question-header">
                    <ul class="list-unstyled d-flex flex-wrap">
                      <li class="ass-questions">
                        <h4>{{ category.name }}</h4>
                      </li>
                    </ul>
                  </div>
                  <div class="new-ass-que-left-content-content">
                    <ng-container class="pdf-question-content-inner" *ngFor="let question of category.questions; index as j">
                      <ul>
                        <li class="questions">{{ j + 1 }}. {{ question.question }}</li>
                        <li
                          class="answers"
                          [class]="{
                            yes: question.assessmentQuestionTypeId == AssessmentQuestionType.Yes,
                            no: question.assessmentQuestionTypeId == AssessmentQuestionType.No,
                            other:
                              question.assessmentQuestionTypeId != AssessmentQuestionType.No &&
                              question.assessmentQuestionTypeId != AssessmentQuestionType.Yes
                          }"
                        >
                          {{ getAssessmentCategoryText(question) }}
                        </li>
                        <li class="percentage">
                          {{ question.unit }}
                        </li>
                        <li class="questions comment">
                          <p>{{ question.answer }}</p>
                        </li>
                      </ul>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="pdf-copyright-wrapper">
          <div class="pdf-copyright-inner">
            <p>Report by Mortgage Profit Plan</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
